import React from 'react';
import { Star, Users } from 'lucide-react';
import { useServerStats } from '@/hooks/useServerStats';

interface ServerCardStatsProps {
  serverId: string;
  fallbackVotes: number;
  playerCount?: string | null;
}

export const ServerCardStats: React.FC<ServerCardStatsProps> = ({
  serverId,
  fallbackVotes,
  playerCount,
}) => {
  const { data: serverStats } = useServerStats(serverId);
  const displayVotes = serverStats?.monthly_votes ?? 0;

  return (
    <div className="flex items-center gap-2 flex-shrink-0">
      {/* Votes */}
      <div className="flex items-center gap-1 bg-slate-800/70 rounded-lg px-2 py-1 border border-yellow-500/20">
        <Star className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" />
        <span className="text-xs font-bold text-yellow-300 tabular-nums">{displayVotes.toLocaleString()}</span>
      </div>
      {/* Joueurs */}
      {playerCount && (
        <div className="flex items-center gap-1 bg-slate-800/70 rounded-lg px-2 py-1 border border-blue-500/20">
          <Users className="w-3 h-3 text-blue-400" />
          <span className="text-[11px] font-semibold text-blue-300 tabular-nums">{playerCount}</span>
        </div>
      )}
    </div>
  );
};
